var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVeryHappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#13C48E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.5 14.0577C19.5 14.5781 19.0523 15 18.5 15C17.9477 15 17.5 14.5781 17.5 14.0577C17.5 12.5976 18.859 11.5 20.5 11.5C22.141 11.5 23.5 12.5976 23.5 14.0577C23.5 14.5781 23.0523 15 22.5 15C21.9477 15 21.5 14.5781 21.5 14.0577C21.5 13.7085 21.099 13.3846 20.5 13.3846C19.901 13.3846 19.5 13.7085 19.5 14.0577Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10 14.0577C10 14.5781 9.55228 15 9 15C8.44772 15 8 14.5781 8 14.0577C8 12.5976 9.35899 11.5 11 11.5C12.641 11.5 14 12.5976 14 14.0577C14 14.5781 13.5523 15 13 15C12.4477 15 12 14.5781 12 14.0577C12 13.7085 11.599 13.3846 11 13.3846C10.401 13.3846 10 13.7085 10 14.0577Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0005 18.5C22.4233 18.5 22.8462 18.6995 23.1537 19.0587C23.4228 19.3779 23.5766 19.8568 23.4613 20.3357C23 24.1268 19.8477 27 16.2342 27C12.6207 27 9.50688 24.1268 9.00713 20.3357C8.96869 19.8568 9.08402 19.4178 9.39155 19.0587C9.69909 18.6995 10.0835 18.5 10.5448 18.5H22.0005ZM13.7355 24.7254C14.5043 25.1244 15.35 25.3639 16.2726 25.3639C17.1952 25.3639 18.041 25.1643 18.8482 24.7254C18.5023 23.6479 17.5028 22.8897 16.3495 22.8498C15.1194 22.8498 14.1199 23.608 13.7355 24.7254Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryHappy);
export default __webpack_public_path__ + "static/media/VeryHappy.44ccd64641cbf7c11f5e30d113626822.svg";
export { ForwardRef as ReactComponent };